import React, { Component } from 'react';

class VideoCta extends Component {


    render() {
        return (
            <div>
                {/*====================  video cta area ====================*/}
                <div className="video-cta-area section-space--inner--120">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="video-cta-content">
                                    <h4 className="video-cta-content__small-title">ABOUT US</h4>
                                    <h3 className="video-cta-content__title">Shakuntla Learn and Fly Foundation</h3>
                                    <p className="video-cta-content__text">
                                        Shakuntla Learn and Fly Foundation is committed to empowering children,
                                        including children with special needs, through quality education,
                                        evidence-based therapies, life skills, and family support. We provide a
                                        safe, inclusive, and nurturing environment where every child can learn,
                                        grow, and achieve their full potential.
                                    </p> <a href={`${process.env.PUBLIC_URL}/contact-us`} className="ht-btn ht-btn--round">CONTACT US</a>
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-1 col-md-6">
                                <div className="cta-video-image">
                                    <img
                                        src="assets/img/backgrounds/about.png"
                                        className="img-fluid"
                                        alt="Shakuntla Learn and Fly Foundation"
                                        style={{ borderRadius: "10px", width: "100%" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of video cta area  ====================*/}
            </div>
        )
    }
}


export default VideoCta;